import { FC } from 'react';
import Skeleton from '../presentational/skeleton';
import { Spinner } from '../presentational/spinner';

const SkeletonGuildMythicPlusPage: FC<any> = () => {
  return (
    <div style={{ marginTop: 24 }}>
      <Skeleton height={31} />
      <Skeleton variant="item" height={979} style={{ position: 'relative' }}>
        <Spinner />
      </Skeleton>
    </div>
  );
};

export default SkeletonGuildMythicPlusPage;

